export default __webpack_public_path__ + "images/8001dd873352031f76d023cd460c8da4.png";